export default __webpack_public_path__ + "static/Maps-7b288b86957448e85c38e6dd723f8632.png";